import React, {FC} from 'react';

import {InboxModel} from '../../../../../libs/shared/core/src/models/api/inboxModel';
import {DropdownProps} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {useAppSelector} from '../../../../helpers/appReduxHelpers';
import {getSharedInboxes} from '../../../../store/data/inboxes/inboxesSelectors';
import {SearchInboxDropdown} from './searchInboxDropdown';

/*
 * Props.
 */

interface SearchInboxCustomFieldDropdownProps extends DropdownProps {
  selectedInboxId: number | undefined;
  shouldShowDeleteOption?: boolean;
  onChange: (model: InboxModel) => void;
  onDelete?: () => void;
}

/*
 * Component.
 */

export const SearchInboxCustomFieldDropdown: FC<SearchInboxCustomFieldDropdownProps> = (props) => {
  const {selectedInboxId, shouldShowDeleteOption, onChange, onDelete, ...dropdownProps} = props;

  const inboxes = useAppSelector(getSharedInboxes);

  return (
    <SearchInboxDropdown
      {...dropdownProps}
      inboxes={inboxes}
      selectedInboxIds={selectedInboxId ? [selectedInboxId] : []}
      shouldShowDeleteOption={shouldShowDeleteOption}
      onChange={onChange}
      onDelete={onDelete}
    />
  );
};
